// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1evA7","title":"ClientInsurance_title__2SdYJ","itemText":"ClientInsurance_itemText__3oN2L"};